<ws-assignment-editor-view 
  [id]="entityId" 
  [cancelable]="cancelable"
  [date]="date"
  [accountId]="accountId"
  (saved)="onSaved()" 
  (canceled)="onCanceled()"></ws-assignment-editor-view>